import React from "react";
import HomeSections from "./home-sections";

function Home() {
  return <HomeSections />;
}

export default Home;
